import { render, staticRenderFns } from "./Model21.vue?vue&type=template&id=d09b2880&scoped=true"
import script from "./Model21.vue?vue&type=script&lang=js"
export * from "./Model21.vue?vue&type=script&lang=js"
import style0 from "./Model21.vue?vue&type=style&index=0&id=d09b2880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09b2880",
  null
  
)

export default component.exports